const dict = {
  languageName: '한국어',
  locale: 'ko',
  fallback: 'en',
  dir: 'ltr',

  // app
  'app.name': 'Kavykhi.Cloud',
  'app.title': (sub) => `${sub} - Kavykhi.Cloud`,

  // themes
  theme: '테마',
  'theme.light': '라이트',
  'theme.dark': '다크',
  'theme.system': '시스템',
  'theme.sakura': '사쿠라',

  // generic
  email: '이메일',
  password: '비밀번호',
  ok: '확인',
  cancel: '취소',
  retry: '재시도',
  copy: '복사',
  empty: '(항목 없음)',
  loading: '로딩 중...',
  calculating: '계산 중...',
  error: '오류',

  'in_development': '이 페이지는 개발 중입니다.',

  // errors
  'error.not_found': '찾을 수 없음',
  'error.name_conflict': '이름 충돌',
  'error.bad_param': '잘못된 매개변수',
  'error.wrong_auth': '잘못된 인증',
  'error.unauthorized': '권한 없음',
  'error.wrong_credentials': '잘못된 자격 증명',
  'error.wrong_provider': '잘못된 제공자',
  'error.insufficient_privileges': '권한 부족',
  'error.not_empty': '비어 있지 않음',
  'error.limit_exceeded': '한도 초과',
  'error.already_member': '이미 멤버임',
  'error.not_finalized': '완료되지 않음',
  'error.already_finalized': '이미 완료됨',
  'error.unexpected_patch': '예기치 않은 패치',
  'error.timeout': '시간 초과',
  'error.not_patch': '패치가 아님',
  'error.not_supported': '지원되지 않음',
  'error.unexpected_error': '예기치 않은 오류',

  // data sizes
  'datasize.B': 'B',
  'datasize.KiB': 'KiB',
  'datasize.MiB': 'MiB',
  'datasize.GiB': 'GiB',
  'datasize.TiB': 'TiB',

  // auth providers
  'auth.provider.steam': 'Steam',
  'auth.provider.github': 'GitHub',
  'auth.provider.gitlab': 'GitLab',
  'auth.provider.itch': 'itch.io',
  'auth.provider.twitch': 'Twitch',
  'auth.provider.discord': 'Discord',
  'auth.provider.google': 'Google',

  // auth dialog
  'auth.dialog.header': '인증',
  'auth.dialog.please_select': '로그인할 계정 제공자를 선택해 주세요.',
  'auth.dialog.redirecting_to': (provider) => `${provider}(으)로 이동 중...`,
  'auth.dialog.remember_me': '로그인 상태 유지',
  'auth.dialog.log_in': '로그인',
  'auth.dialog.back': '이전',
  'auth.dialog.progress_header': '인증 중...',
  'auth.dialog.error.header': '인증 오류',
  'auth.dialog.error.auth_not_allowed': '이 자격 증명은 사용자가 인증에 사용하지 못하도록 금지했습니다. 다른 자격 증명을 사용해 주세요.',
  'auth.dialog.error.unknown': '잘못된 인증 매개변수입니다. 다시 시도해 주세요.',
  'auth.dialog.error.back': '돌아가기',

  'user.profile': '프로필',
  'user.logout': '로그아웃',

  // deploy credential providers
  'deploy_credential_provider.steam': 'Steam',
  'deploy_credential_provider.itch': 'itch.io',

  'page_not_found.header': '페이지를 찾을 수 없음',
  'page_not_found.message': '이 페이지는 존재하지 않습니다.',
  'page_not_found.message2': '이전에는 있었을 수 있으나 현재는 아무것도 없습니다. 다음과 같은 가능성이 있습니다.',
  'page_not_found.items': [
    '이전에 여기에 무언가 있었으나 지금은 삭제되었습니다.',
    '아직 여기에 무언가 있으나 접근 권한이 없습니다.',
    '또는 링크를 복사하여 붙여넣는 동안 실수가 있었습니다.',
  ],

  'home': '홈',
  'home.header.hint': '인디 개발자를 위한 클라우드 도구',
  'home.description': 'Kavykhi.Cloud는 인디 게임 개발 플랫폼입니다. 다운로드형 및 브라우저 게임, 비공개 및 공개 빌드, 브랜치, 팀 등 다양한 기능을 지원합니다.',
  'home.auth': '로그인 또는 가입',
  'home.auth.hint': '새 계정 생성 또는 기존 계정 로그인',

  'projects': '프로젝트',
  'projects.hint': '작업 중인 프로젝트',
  'projects.project': (project) => `프로젝트: ${project}`,
  'projects.project.hint': '프로젝트',
  'projects.no_projects': '아직 프로젝트가 없습니다.',
  'projects.new': '프로젝트 생성',
  'projects.new_dialog.header': '새 프로젝트',
  'projects.new_dialog.label': '프로젝트 이름',
  'projects.new_dialog.ok': '프로젝트 생성',
  'projects.store_page': '공개 스토어 페이지',
  'projects.description': '설명',
  'projects.branches': '브랜치',
  'projects.versions': '버전',
  'projects.packages': '패키지',
  'projects.management': '프로젝트 설정',
  'projects.management.breadcrumb': '설정',
  'projects.management.title': (projectTitle) => `${projectTitle} - 설정`,
  'projects.management.hint': '프로젝트 설정',
  'projects.management.users': '팀 멤버',
  'projects.management.users.empty': '팀 멤버가 없습니다.',
  'projects.management.users.role.tester': '테스터',
  'projects.management.users.role.developer': '개발자',
  'projects.management.users.role.admin': '관리자',
  'projects.management.users.role.owner': '소유자',
  'projects.management.users.role.starred': '스타 표시됨',
  'projects.management.users.exile': '팀에서 제거',
  'projects.management.users.exile.dialog.header': '팀에서 제거',
  'projects.management.users.exile.dialog.message': (projectTitle, userTitle) => <>{projectTitle} 프로젝트에서 {userTitle}님을 제거하시겠습니까?</>,
  'projects.management.users.exile.dialog.ok': '팀에서 제거',
  'projects.management.invites.one_time_invite': '일회용 초대 링크',
  'projects.management.invites.one_time_invite.header': '일회용 초대 링크',
  'projects.management.invites.one_time_invite.message': '일회용 초대 링크:',
  'projects.management.invites.one_time_invite.note': '24시간 동안 유효하며, 한 번만 사용할 수 있습니다.',
  'projects.management.invites.new_dialog.header': '초대 링크',
  'projects.management.invites.new_dialog.expires': '만료 시간:',
  'projects.management.invites.new_dialog.expires.indefinite': '(만료 없음)',
  'projects.management.invites.new_dialog.approval.label': '사용자 프로젝트 가입:',
  'projects.management.invites.new_dialog.approval.not_approved': '관리자 승인 후',
  'projects.management.invites.new_dialog.approval.approved': '즉시',
  'projects.management.invites.new_dialog.seats': '가입 제한:',
  'projects.management.invites.new_dialog.seats.no_limit': '(제한 없음)',
  'projects.management.invites.new_dialog.ok': '초대 링크 생성',
  'projects.management.deploy_sites': '배포 사이트',
  'projects.management.deploy_sites.empty': '추가된 배포 사이트가 없습니다.',
  'projects.management.deploy_sites.add': '배포 사이트 추가',
  'projects.management.deploy_sites.delete': '삭제',
  'projects.management.deploy_sites.delete_dialog.header': '배포 사이트 삭제',
  'projects.management.deploy_sites.delete_dialog.message': (provider, site) => <>{provider} 배포 사이트 {site}을(를) 삭제하시겠습니까?</>,
  'projects.management.deploy_sites.delete_dialog.ok': '배포 사이트 삭제',
  'projects.management.public_access': '공개 접근',
  'projects.management.public_access.enable': '공개 접근 활성화',
  'projects.management.public_access.enabled': <>공개 접근: <strong>허용됨</strong></>,
  'projects.management.public_access.enabled.note': '프로젝트의 이름과 설명, 그리고 공개로 표시된 모든 브랜치가 공개됩니다.',
  'projects.management.public_access.enable_dialog.header': '공개 접근 활성화',
  'projects.management.public_access.enable_dialog.message': (projectTitle) => <>{projectTitle} 프로젝트에 대한 공개 접근을 허용하시겠습니까?<br /><br />이렇게 하면 인증 없이 프로젝트에 대한 기본 정보를 볼 수 있게 됩니다. 공개하려는 각 브랜치에 대해 개별적으로 공개 접근을 활성화해야 합니다.</>,
  'projects.management.public_access.enable_dialog.ok': '공개 접근 활성화',
  'projects.management.public_access.disable': '공개 접근 비활성화',
  'projects.management.public_access.disabled': <>공개 접근: <strong>허용 안 됨</strong></>,
  'projects.management.public_access.disabled.note': '프로젝트가 비공개 상태입니다. 프로젝트 팀 멤버만 접근할 수 있습니다.',
  'projects.management.public_access.disable_dialog.header': '공개 접근 비활성화',
  'projects.management.public_access.disable_dialog.message': (projectTitle) => <>{projectTitle} 프로젝트에 대한 모든 공개 접근을 비활성화하시겠습니까?</>,
  'projects.management.public_access.disable_dialog.ok': '공개 접근 비활성화',
  'projects.management.public_access.branches': '공개 브랜치',
  'projects.management.manage': '프로젝트 관리',
  'projects.rename': '프로젝트 이름 변경',
  'projects.rename_dialog.header': '프로젝트 이름 변경',
  'projects.rename_dialog.label': '프로젝트 이름:',
  'projects.rename_dialog.ok': '프로젝트 이름 변경',
  'projects.edit_description': '프로젝트 설명 수정',
  'projects.edit_description_dialog.header': '프로젝트 설명 수정',
  'projects.edit_description_dialog.label': '프로젝트 설명:',
  'projects.edit_description_dialog.ok': '설명 수정',
  'projects.leave': '프로젝트 탈퇴',
  'projects.leave_dialog.header': '프로젝트 탈퇴',
  'projects.leave_dialog.message': (projectTitle) => <>{projectTitle} 프로젝트에서 탈퇴하시겠습니까?</>,
  'projects.leave_dialog.ok': '프로젝트 탈퇴',
  'projects.delete': '프로젝트 삭제',
  'projects.delete_dialog.header': '프로젝트 삭제',
  'projects.delete_dialog.message': (projectTitle) => <>{projectTitle} 프로젝트를 삭제하시겠습니까?</>,
  'projects.delete_dialog.ok': '프로젝트 삭제',

  'branches.header': (projectTitle, branchTitle) => `${projectTitle}: ${branchTitle}`,
  'branches.header.hint': '브랜치',
  'branches.no_branches': '프로젝트에 아직 브랜치가 없습니다.',
  'branches.new': '브랜치 생성',
  'branches.new_dialog.header': '새 브랜치',
  'branches.new_dialog.label': '브랜치 이름',
  'branches.new_dialog.ok': '브랜치 생성',
  'branches.current_version': (version) => <>현재 버전: {version}</>,
  'branches.current_version.packages': '현재 버전 패키지',
  'branches.no_current_version': '현재 버전 없음',
  'branches.publish_version.new': '새 버전 게시',
  'branches.publish_version.existing': '기존 버전 다시 게시',
  'branches.version_history': '버전 기록',
  'branches.version_history.empty': '브랜치의 버전 기록이 비어 있습니다.',
  'branches.version_history.note_removal': ({ quotaCount, quotaCountText, quotaNonCurrentTime, quotaTime }) => <>현재 브랜치 버전은 {quotaTime != null ? <>{quotaTime} 동안</> : <>무기한</>} 유지됩니다. 이전 버전은 최대 {quotaNonCurrentTime} 동안 유지됩니다. 브랜치당 총 {plural(quotaCount, <>{quotaCountText}개 버전</>, <>{quotaCountText}개 버전</>)}까지만 유지됩니다.</>,
  'branches.manage': '브랜치 관리',
  'branches.rename': '브랜치 이름 변경',
  'branches.rename_dialog.header': '브랜치 이름 변경',
  'branches.rename_dialog.label': '브랜치 이름:',
  'branches.rename_dialog.ok': '브랜치 이름 변경',
  'branches.delete': '브랜치 삭제',
  'branches.delete_dialog.header': '브랜치 삭제',
  'branches.delete_dialog.message': (branchTitle) => <>{branchTitle} 브랜치를 삭제하시겠습니까?</>,
  'branches.delete_dialog.ok': '브랜치 삭제',

  'versions.header': (projectTitle, versionTitle) => `${projectTitle} ${versionTitle}`,
  'versions.header.hint': '버전',
  'versions.current': '현재',
  'versions.previous': '이전',
  'versions.description': '설명',
  'versions.deploy_to_site.header': '사이트에 게시',
  'versions.deploy_to_site': '사이트에 게시',
  'versions.packages': '패키지',
  'versions.branches': '포함된 브랜치',
  'versions.branches.publish': '브랜치에 게시',
  'versions.branches.empty': '이 버전은 어떤 브랜치에도 게시되지 않았습니다.',
  'versions.new_dialog.header': '새 버전',
  'versions.new_dialog.label_title': '버전:',
  'versions.new_dialog.label_branch': '브랜치:',
  'versions.new_dialog.packages.header': '패키지',
  'versions.new_dialog.packages.empty': '추가된 패키지가 없습니다.',
  'versions.new_dialog.packages.add': '패키지 추가',
  'versions.new_dialog.packages.add_existing': '이전에 업로드된 패키지 추가',
  'versions.new_dialog.packages.replace': '패키지 교체',
  'versions.new_dialog.packages.edit': '패키지 편집',
  'versions.new_dialog.ok': '버전 생성',
  'versions.manage': '버전 관리',
  'versions.rename': '버전 이름 변경',
  'versions.rename_dialog.header': '버전 이름 변경',
  'versions.rename_dialog.label': '버전 이름:',
  'versions.rename_dialog.ok': '버전 이름 변경',
  'versions.edit_description': '버전 설명 수정',
  'versions.edit_description_dialog.header': '버전 설명 수정',
  'versions.edit_description_dialog.label': '버전 설명:',
  'versions.edit_description_dialog.ok': '설명 수정',
  'versions.delete': '버전 삭제',
  'versions.delete_dialog.header': '버전 삭제',
  'versions.delete_dialog.message': (versionTitle) => <>버전 {versionTitle}을(를) 삭제하시겠습니까?</>,
  'versions.delete_dialog.ok': '버전 삭제',

  'versions.publish_dialog.header': '브랜치에 버전 게시',
  'versions.publish_dialog.message': (versionTitle) => <>버전 {versionTitle}을(를) 게시할 브랜치를 선택하세요.</>,
  'versions.publish_dialog.no_branches': '프로젝트에 브랜치가 없습니다.',
  'versions.publish_dialog.ok': '버전 게시',

  'versions.publish_existing_dialog.header': '버전 다시 게시',
  'versions.publish_existing_dialog.message': '최근 버전:',
  'versions.publish_existing_dialog.no_versions': '프로젝트에 버전이 없습니다.',
  'versions.publish_existing_dialog.ok': '버전 게시',

  'packages.header': (projectTitle, packageTitle) => `${projectTitle}: ${packageTitle}`,
  'packages.header.hint': '패키지',
  'packages.download_zip': 'ZIP으로 다운로드',
  'packages.download_torrent': '토렌트 다운로드',
  'packages.total_size': (size) => <>총 크기: {size}</>,
  'packages.manage': '패키지 관리',
  'packages.rename': '패키지 이름 변경',
  'packages.rename_dialog.header': '패키지 이름 변경',
  'packages.rename_dialog.label': '패키지 이름:',
  'packages.rename_dialog.ok': '패키지 이름 변경',
  'packages.edit_tags': '패키지 태그 수정',
  'packages.edit_tags_dialog.header': '패키지 태그 수정',
  'packages.edit_tags_dialog.message': (packageTitle) => <>패키지 {packageTitle}의 태그를 지정하세요:</>,
  'packages.edit_tags_dialog.ok': '패키지 태그 설정',
  'packages.entrypoint': (entrypoint) => <>시작 파일: {entrypoint}</>,
  'packages.entrypoint.empty': '시작 파일이 설정되지 않았습니다.',
  'packages.delete': '패키지 삭제',
  'packages.delete_dialog.header': '패키지 삭제',
  'packages.delete_dialog.message': (packageTitle) => <>패키지 {packageTitle}을(를) 삭제하시겠습니까? 이 패키지가 추가된 모든 버전에서 삭제됩니다.</>,
  'packages.delete_dialog.ok': '패키지 삭제',

  'packages.new_dialog.header': '새 패키지',
  'packages.new_dialog.label_title': '제목:',
  'packages.new_dialog.title_placeholder': '(태그에서 가져옴)',
  'packages.new_dialog.tags.header': '태그',
  'packages.new_dialog.files.header': '파일',
  'packages.new_dialog.total_size': (size, maximum) => <>총 크기: {size} {maximum}</>,
  'packages.new_dialog.total_size.maximum': (size) => <>(최대 {size})</>,
  'packages.new_dialog.new_data_size': (size) => <>새 데이터 크기: {size}</>,
  'packages.new_dialog.checks.empty': '추가된 파일이 없습니다.',
  'packages.new_dialog.checks.entrypoint.empty': '시작 파일이 설정되지 않았습니다.',
  'packages.new_dialog.checks.entrypoint.missing': (entrypoint) => <>시작 파일 {entrypoint}이(가) 존재하지 않습니다. 추가하는 것을 잊으셨나요? 존재하는 시작 파일을 지정하거나 시작 파일을 설정하지 않을 수 있습니다.</>,
  'packages.new_dialog.checks.entrypoint.missing.action': '시작 파일 설정 해제',
  'packages.new_dialog.checks.entrypoint.ext.tag': (fileExt, tag) => <>시작 파일의 확장자가 {fileExt}입니다. {tag} 태그를 권장합니다.</>,
  'packages.new_dialog.checks.entrypoint.ext.tag.action': (tag) => <>{tag} 태그 추가</>,
  'packages.new_dialog.checks.entrypoint.ext.html': (fileExt, tag) => <>시작 파일의 확장자가 {fileExt}입니다. 브라우저에서 패키지를 실행할 수 있도록 {tag} 태그를 추가하세요.</>,
  'packages.new_dialog.checks.entrypoint.ext.wrong': (fileExt) => <>시작 파일의 확장자가 {fileExt}입니다. 실수인가요? 보통 시작할 수 있는 파일 형식이 아닙니다.</>,
  'packages.new_dialog.checks.entrypoint.ext.archive': (fileExt) => <>시작 파일의 확장자가 {fileExt}입니다. 아카이브 파일로 묶는 것보다 실제 콘텐츠 파일을 포함하는 것을 권장합니다.</>,
  'packages.new_dialog.checks.entrypoint.executable': '시작 파일이 실행 가능으로 표시되지 않았습니다.',
  'packages.new_dialog.checks.entrypoint.executable.action': '실행 가능으로 표시',
  'packages.new_dialog.checks.single_root_dir': '루트에 단일 디렉토리를 두는 것보다 파일을 루트에 직접 배치하는 것을 권장합니다.',
  'packages.new_dialog.checks.single_root_dir.action': '폴더를 해당 내용물로 교체',

  'packages.add_existing_dialog.header': '패키지 추가',
  'packages.add_existing_dialog.add': (packagesCount) => packagesCount > 0 ? `${plural(packagesCount, `${packagesCount}개 패키지`, `${packagesCount}개 패키지`)} 추가` : '선택된 패키지 없음',
  'packages.add_existing_dialog.message': '최근 업로드된 패키지:',
  'packages.add_existing_dialog.no_packages': '최근 업로드된 패키지가 없습니다.',

  'packages.launch': '실행',

  'packages.install': '설치',
  'packages.install_dialog.header': '설치',
  'packages.install_dialog.workdir.label': '작업 디렉토리:',
  'packages.install_dialog.workdir.value.new': '(새로 만들기)',
  'packages.install_dialog.workspace.label': '폴더 생성 위치:',
  'packages.install_dialog.workspace.placeholder': '(루트 폴더 선택)',
  'packages.install_dialog.ok': '설치',

  'packages.update': '업데이트',

  'packages.upload.status.existing': '이전 버전에서 가져옴',
  'packages.upload.status.queued': '대기 중',
  'packages.upload.status.packing': '패킹 중...',
  'packages.upload.status.creating': '생성 중...',
  'packages.upload.status.create_retrying': '생성 실패, 대기 후 재시도 중',
  'packages.upload.status.splitting': '분할 중...',
  'packages.upload.status.uploading': '업로드 중...',
  'packages.upload.status.finalizing': '완료 중...',
  'packages.upload.status.finalize_retrying': '완료 실패, 대기 후 재시도 중',
  'packages.upload.status.resolving': '패치 확인 중...',
  'packages.upload.status.resolve_retrying': '패치 확인 실패, 대기 후 재시도 중...',
  'packages.upload.status.done': '업로드 성공',
  'packages.upload.status.errored': '오류',

  'packages.upload.part.status.queued': '대기 중',
  'packages.upload.part.status.hashing': '해싱 중',
  'packages.upload.part.status.upload_queued': '업로드 대기 중',
  'packages.upload.part.status.uploading': '업로드 중',
  'packages.upload.part.status.upload_retrying': '오류 발생, 업로드 재시도 중',
  'packages.upload.part.status.upload_finalizing': '업로드 완료 중',
  'packages.upload.part.status.upload_errored': '오류',
  'packages.upload.part.status.done': '업로드됨',

  'packages.play': '브라우저에서 플레이',
  'packages.play.reset': '초기화',
  'packages.play.fullscreen': '전체 화면',

  'deploy_sites.add_dialog.header': '배포 사이트 추가',
  'deploy_sites.add_dialog.message': (projectTitle) => <>배포 자격 증명을 선택하고 사이트 URL을 입력하여 {projectTitle} 프로젝트의 배포 사이트로 저장하세요.</>,
  'deploy_sites.add_dialog.label_credential': '배포 자격 증명:',
  'deploy_sites.add_dialog.select_credential': '자격 증명 선택',
  'deploy_sites.add_dialog.select_credential.new': '새 자격 증명 추가...',
  'deploy_sites.add_dialog.label_select_site': '사이트 선택:',
  'deploy_sites.add_dialog.select_credential_first': '(자격 증명을 먼저 선택하세요)',
  'deploy_sites.add_dialog.select_site': '(사이트 선택)',
  'deploy_sites.add_dialog.label_enter_site': '또는 사이트 URL 입력:',
  'deploy_sites.add_dialog.ok': '사이트 추가',

  'deploy_to_site_dialog.header': '사이트에 게시',
  'deploy_to_site_dialog.message': (projectTitle, versionTitle) => <>{projectTitle}의 {versionTitle} 버전을 게시할 사이트를 선택하세요.</>,
  'deploy_to_site_dialog.label_site': '사이트에 게시:',
  'deploy_to_site_dialog.select_site': '사이트 선택',
  'deploy_to_site_dialog.select_site.new': '새 배포 사이트 추가...',
  'deploy_to_site_dialog.packages.message.itch': <>패키지는 <a href="https://itch.io/docs/butler/pushing.html" target="_blank">butler</a>를 사용하여 itch.io에 게시됩니다. 채널 이름은 패키지 태그에서 파생됩니다.</>,
  'deploy_to_site_dialog.deploy': '게시',
  'deploy_to_site_dialog.close': '닫기',
  'deploy_to_site_dialog.error.no_packages': '게시할 패키지가 없습니다.',
  'deploy_to_site_dialog.error.non_unique_channels': ({ packagesCount, packagesCountText, channel }) => <>단일 채널에 여러 패키지를 게시할 수 없습니다. 현재 {channel} 채널에 게시하도록 설정된 패키지가 {plural(packagesCount, <>{packagesCountText}개</>, <>{packagesCountText}개</>)} 있습니다.</>,
  'deploy_to_site_dialog.job.queued': '대기 중',
  'deploy_to_site_dialog.job.downloading': '다운로드 중...',
  'deploy_to_site_dialog.job.unpacking': '압축 해제 중...',
  'deploy_to_site_dialog.job.uploading': '게시 중...',
  'deploy_to_site_dialog.job.succeeded': '성공',
  'deploy_to_site_dialog.job.errored': '오류',

  'store': '스토어',
  'store.hint': '공개 프로젝트',
  'store.project.hint': '스토어 프로젝트 페이지',
  'store.project.owner': '개발자',
  'store.project.description': '설명',
  'store.project.star': '스타 추가',
  'store.project.starred': '스타 표시됨',
  'store.project.content': '콘텐츠',
  'store.project.content.warning': '이 콘텐츠는 제3자 개발자에 의해 제공되었습니다.',
  'store.project.branch_version': (branchTitle, versionTitle) => <>{branchTitle} 브랜치: 버전 {versionTitle}</>,
  'store.project.branch_version.published': (branchVersionPublished) => <>게시일: {branchVersionPublished}</>,

  'me': '프로필',
  'me.hint': '프로필 설정 및 연결된 자격 증명',
  'me.rename': '프로필 이름 변경',
  'me.rename_dialog.header': '프로필 이름 변경',
  'me.rename_dialog.label_title': '이름:',
  'me.rename_dialog.ok': '프로필 이름 변경',
  'me.credentials': '자격 증명',
  'me.credentials.hint.auth_allowed': '이 자격 증명 중 하나를 사용하여 이 계정에 로그인할 수 있습니다.',
  'me.credentials.hint.auth_disallowed': '이 자격 증명은 계정에 연결되어 있지만 로그인에 사용할 수 없습니다.',
  'me.credentials.empty': '자격 증명이 없습니다.',
  'me.credentials.empty.auth_allowed.warning': '계정이 잠길 수 있습니다! 로그인할 수 있는 자격 증명이 연결되어 있지 않습니다. 가능한 한 빨리 로그인할 수 있는 자격 증명을 연결해 주세요.',
  'me.credentials.profile_picture.alt': (provider) => `${dict[`auth.provider.${provider}`]} 프로필 사진`,
  'me.credentials.created': (created) => <>추가됨: {created}</>,
  'me.credentials.last_used': (lastUsed) => <>최근 사용: {lastUsed}</>,
  'me.credential.unlink': '연결 해제',
  'me.credential.allow_auth': '로그인 허용',
  'me.credential.disallow_auth': '로그인 비허용',
  'me.credential.display_publicly': '공개 표시',
  'me.credential.dont_display_publicly': '공개 표시 안 함',
  'me.credential.link': '자격 증명 연결',
  'me.credential.link_dialog.header': '자격 증명 연결',
  'me.credential.link_dialog.message': '연결할 계정 제공자를 선택해 주세요.',
  'me.credential.unlink_dialog.header': '자격 증명 연결 해제',
  'me.credential.unlink_dialog.are_you_sure': (credentialProvider, credentialTitle) => <>Kavykhi.Cloud 계정에서 {credentialProvider} 계정 {credentialTitle}의 연결을 해제하시겠습니까?</>,
  'me.credential.unlink_dialog.ok': '자격 증명 연결 해제',
  'me.sessions': '세션',
  'me.sessions.hint': '현재 브라우저를 포함한 활성 세션 목록입니다.',
  'me.sessions.started': (started) => <>시작됨 <span class="value">{started}</span></>,
  'me.sessions.last_auth': (lastAuth) => <>활동 <span class="value">{lastAuth}</span></>,
  'me.sessions.current': '현재 세션',
  'me.sessions.empty': '세션이 없습니다.',
  'me.sessions.delete': '종료',
  'me.sessions.delete_dialog.header': '세션 종료',
  'me.sessions.delete_dialog.message': '이 세션을 종료하시겠습니까?',
  'me.sessions.delete_dialog.ok': '세션 종료',
  'me.api_tokens': 'API 토큰',
  'me.api_tokens.hint': '자동화에 사용할 API 토큰을 여기에서 생성할 수 있습니다.',
  'me.api_tokens.started': (started) => <>생성됨 <span class="value">{started}</span></>,
  'me.api_tokens.expires': (expires) => <>만료일 <span class="value">{expires}</span></>,
  'me.api_tokens.no_expiration': '만료 없음',
  'me.api_tokens.empty': 'API 토큰이 없습니다.',
  'me.api_tokens.create': 'API 토큰 생성',
  'me.api_tokens.create_dialog.header': 'API 토큰 생성',
  'me.api_tokens.create_dialog.message': '생성된 API 토큰:',
  'me.api_tokens.create_dialog.note': '토큰은 다시 표시되지 않으므로 안전하게 저장해 주세요.',
  'me.api_tokens.delete': '삭제',
  'me.api_tokens.delete_dialog.header': 'API 토큰 삭제',
  'me.api_tokens.delete_dialog.message': '이 토큰을 삭제하시겠습니까?',
  'me.api_tokens.delete_dialog.ok': 'API 토큰 삭제',
  'me.deploy_credentials': '배포 자격 증명',
  'me.deploy_credentials.hint': '게시 플랫폼에 배포하기 위한 자격 증명을 여기에서 추가할 수 있습니다.',
  'me.deploy_credentials.empty': '추가된 배포 자격 증명이 없습니다.',
  'me.deploy_credential.add': '배포 자격 증명 추가',
  'me.deploy_credential.add_dialog.header': '배포 자격 증명 추가',
  'me.deploy_credential.add_dialog.label_site': '사이트:',
  'me.deploy_credential.add_dialog.label_title': '메모:',
  'me.deploy_credential.add_dialog.label_key': '키:',
  'me.deploy_credential.add_dialog.default_title': (date) => `키 ${date}`,
  'me.deploy_credential.add_dialog.ok': '배포 자격 증명 추가',
  'me.deploy_credential.add_dialog.hint.itch': <>itch.io API 키를 생성하려면 itch.io의 <a href="https://itch.io/user/settings/api-keys" target="_blank">프로필 설정</a>으로 이동하세요. 소스가 "web" 또는 "wharf"인 기존 API 키를 사용할 수 있습니다. 소스가 "Kavykhi.Cloud"인 API 키는 작동하지 않습니다.</>,
  'me.deploy_credential.add_dialog.error.not_supported': (credentialProvider) => <>현재 {credentialProvider} 자격 증명 추가는 지원하지 않습니다.</>,
  'me.deploy_credential.delete': '삭제',
  'me.deploy_credential.delete_dialog.header': '배포 자격 증명 삭제',
  'me.deploy_credential.delete_dialog.message': (credentialTitle, credentialProvider) => <>{credentialProvider}의 자격 증명 {credentialTitle}을(를) 삭제하시겠습니까? 이 자격 증명으로 구성된 모든 배포 사이트도 프로젝트에서 제거됩니다.</>,
  'me.deploy_credential.delete_dialog.ok': '자격 증명 삭제',
  'me.public_profile': '공개 프로필',
  'me.public_profile.public_credentials': '공개 자격 증명',
  'me.public_profile.public_credentials.hint': '공개로 표시할 자격 증명을 선택하세요.',
  'me.manage': '계정 관리',
  'me.delete': '계정 삭제',
  'me.delete.dialog.header': '계정 삭제',
  'me.delete.dialog.message': (userTitle) => <>Kavykhi.Cloud 계정 {userTitle}을(를) 영구히 삭제하시겠습니까?</>,
  'me.delete.dialog.ok': '계정 삭제',

  'invite': '초대',
  'invite.hint': '프로젝트 초대',
  'invite.message.already_member': (projectTitle) => <>이미 {projectTitle} 프로젝트의 멤버입니다.</>,
  'invite.message.join': (projectTitle) => <>{projectTitle} 프로젝트에 초대되었습니다.</>,
  'invite.join': '프로젝트 가입',

  'local': '로컬 콘텐츠',
  'local.hint': '로컬에 설치된 콘텐츠',
  'local.workdirs': '설치된 패키지',
  'local.workdirs.empty': '설치된 패키지가 없습니다.',
  'local.workdir.action.launch': '실행',
  'local.workdir.action.repair': '복구',
  'local.workdir.action.delete': '제거',
  'local.workdir.delete_dialog.header': '패키지 제거',
  'local.workdir.delete_dialog.message': (packageTitle) => <>기기에서 {packageTitle} 패키지를 제거하시겠습니까?</>,
  'local.workdir.delete_dialog.ok': '제거',
  'local.workspaces': '루트 폴더',
  'local.app_not_detected.message': 'Kavykhi.Cloud 로컬 앱이 감지되지 않았습니다. 아래 링크 중 하나를 사용하여 다운로드하고 설치해 주세요. 이미 설치했다면 실행 중인지 확인하세요.',

  'local_app.detected': '로컬 콘텐츠',

  'error_dialog.header': '오류',
  'error_dialog.messageFunc': (e) => `오류: ${dict[`error.${e}`] ?? e}.`,

  'upload_box.choose_files': '파일 선택',
  'upload_box.choose_directories': '폴더 선택',
  'upload_box.add.progress_dialog.header': '파일 추가 중',
  'upload_box.add.progress_dialog.message': '파일 처리 중...',
  'upload_box.delete': (itemsCount) => `${plural(itemsCount, `${itemsCount}개 항목`, `${itemsCount}개 항목`)} 삭제`,
  'upload_box.start_upload': '업로드 시작',
  'upload_box.drop_area.message': '여기에 파일 및 폴더 드롭',
  'upload_box.drop_area.box_dropping_message': '루트에 넣으려면 여기에 드롭',
  'upload_box.entry.explode_folder': '폴더를 해당 내용물로 교체',
  'upload_box.entry.set_entrypoint': '시작 파일로 설정',
  'upload_box.entry.mark_executable': '실행 가능으로 표시',
  'upload_box.entry.unmark_executable': '실행 가능 표시 해제',
  'upload_box.entry.remove': '제거',

  'package.tags.empty': '(태그 없음)',
  'package.tag.os': 'OS',
  'package.tag.os:windows': 'Windows',
  'package.tag.os:linux': 'Linux',
  'package.tag.os:macos': 'macOS',
  'package.tag.os:android': 'Android',
  'package.tag.os:ios': 'iOS',
  'package.tag.os:web': 'Web',
  'package.tag.arch': '아키텍처',
  'package.tag.arch:x86': 'x86',
  'package.tag.arch:arm': 'ARM',
  'package.tag.bits': '비트 수',
  'package.tag.bits:64': '64비트',
  'package.tag.bits:32': '32비트',
  'package.tag.packaging': '패키징',
  'package.tag.packaging:installer': '설치 프로그램',
  'package.tag.packaging:deb': '.deb',
  'package.tag.packaging:rpm': '.rpm',
  'package.tag.packaging:flatpak': 'Flatpak',
  'package.tag.component': '구성 요소',
  'package.tag.component:client': '클라이언트',
  'package.tag.component:server': '서버',
  'package.tag.runtime': '런타임',
  'package.tag.runtime:nodejs': 'Node.js',
  'package.tag.runtime:java': 'Java',
  'package.tag.distro': 'Linux 배포판',
  'package.tag.distro:ubuntu': 'Ubuntu',
  'package.tag.distro:fedora': 'Fedora',
  'package.tag.distro:arch': 'Arch Linux',
  'package.tag.distro:nixos': 'NixOS',

  'docs': '문서',
  'docs.page_no_language': '이 언어로는 제공되지 않습니다',
  'docs.page_no_language.message': '이 문서의 다른 언어 버전:',
  'docs.page_no_language.other_link': (doc, lang) => <>({lang}) {doc}</>,

  'social_links.discord': 'Discord',

  'report_content': '콘텐츠 신고',
  'report_content.dialog.header': '콘텐츠 신고',
  'report_content.dialog.link': '이메일로 신고 보내기',
  'report_content.dialog.message': (email, link) => <>신고를 보내려면 링크를 클릭하세요:<br /><br />{link}<br /><br />또는 {email}(으)로 직접 이메일을 보내주세요.</>,
};

export default dict;

const plural = (n: number, one: string, many: string) => n == 1 ? one : many;
